import { cenario, volumeParaMeta, type Cenario, type Parametros } from '@favo/core';

import { formatarPercentual, formatarPercentualPontos } from '@/design/formato';

import { faltaPreencher } from './frases';

/**
 * O volume que, AO PREÇO ATUAL, entrega a meta, com o motivo por escrito
 * quando ele não existe.
 *
 * A CONTA é do `core` (`volumeParaMeta`): é regra de negócio, o inverso da
 * premissa do rateio por volume, e fora do pacote viraria a próxima
 * divergência no dia em que o painel quisesse mostrar o mesmo número. O que
 * mora aqui é a tradução para texto e o cenário da coluna, que sai de
 * `cenario()` como o resto do documento, para que faturamento, margem e lucro
 * fechem entre si por construção.
 */
export type Necessario =
  | { tipo: 'ok'; volume: number; cen: Cenario }
  | { tipo: 'indisponivel'; motivo: string };

export function volumeNecessario(p: Parametros, atual: Cenario | null): Necessario {
  if (!atual || !(p.ticket > 0) || !(p.V12 > 0)) {
    return { tipo: 'indisponivel', motivo: faltaPreencher(p) };
  }
  const alvo = p.lucroAlvo / 100;
  if (atual.mcPct === null || atual.mcPct <= alvo) {
    return {
      tipo: 'indisponivel',
      motivo: `Não existe volume que entregue a meta ao preço atual: a margem de contribuição (${formatarPercentual(atual.mcPct)}) não supera a meta de lucro (${formatarPercentualPontos(p.lucroAlvo)}). Cada venda a mais traz junto a mesma margem curta, então a correção passa pelo preço ou pelos custos.`,
    };
  }
  if (!(p.despFixa > 0)) {
    return {
      tipo: 'indisponivel',
      motivo:
        'Sem despesa fixa cadastrada não existe volume mínimo: a meta é atingida em qualquer volume.',
    };
  }
  const volume = volumeParaMeta(p);
  if (volume === null) {
    return {
      tipo: 'indisponivel',
      motivo:
        'A margem por venda é próxima demais da meta para que exista um volume mínimo utilizável.',
    };
  }
  return { tipo: 'ok', volume, cen: cenario(p.ticket, { ...p, V12: volume }) };
}
